import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SentenceInput } from './input.content.js';
import { draggable } from './input.draggable.style.js';
import { jsx } from 'react/jsx-runtime';

function DraggableInput(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({
    id: props.node.id
  });
  return /*#__PURE__*/jsx("div", {
    ref: setNodeRef,
    className: draggable,
    "data-is-dragged": props.isDraggingItem,
    style: {
      transition,
      transform: CSS.Translate.toString(transform),
      opacity: props.isDraggingItem ? 0.5 : 1
    },
    ...attributes,
    ...listeners,
    children: /*#__PURE__*/jsx(SentenceInput, {
      ...props
    })
  });
}

export { DraggableInput };
//# sourceMappingURL=input.draggable.js.map
